<template>
  <div class="product-data">
    <Header/>
    <div class="content">
      <div class="left">
        <div class="tree-custom">
          <div class="parent" :style="{'max-height':(expend?'40px':productList.length*40+40+'px')}">
            <div class="parent-name" @click="expend = !expend">
              <div class="parent-name-left">
                <img src="@/assets/image/product-upload/wdcp.png" alt="">
                {{ $t('header.DataResource') }}
              </div>
              <span class="el-icon-arrow-down parent-name-right" :class="expend?'top':'down'"></span>
            </div>
            <div class="child">
              <div class="child-site" v-for="(i,index) in productList" :key="index">
                <img src="@/assets/image/product-upload/xuanzhongjiantou.png" alt="">
                <span :title="i" @click="changeIs(i);activeIndex = index" :class="activeIndex === index?'active':''">
                  {{ i }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <p style="margin-bottom: 35px;color: rgba(16, 16, 16, 100);font-size: 14px" v-if="tableList.length">{{tableList[0].remark.split('。')[0]}}。<br>{{tableList[0].remark.split('。')[1]}}</p>
        <el-table
            :data="tableList"
            height="700"
            :empty-text="$t('Intelligent.NoData')"
            style="width: 100%">
          <el-table-column
              prop="product"
              :label="$t('DataSubmission.ProductName')"
              width="400">
          </el-table-column>
          <el-table-column
              prop="address"
              :label="$t('services.path')">
          </el-table-column>
          <el-table-column
              :label="$t('services.Operation')"
              width="100">
            <template slot-scope="scope">
              <span @click="copy(scope.row)" style="color:#267dff;cursor:pointer;">{{ $t('services.copy') }}</span>
            </template>
          </el-table-column>
          <el-table-column
              :label="$t('services.introduce')"
              width="100">
            <template slot-scope="scope">
              <span @click="openPDF(scope.row)"
                    style="color:#267dff;cursor:pointer;">{{ $t('Intelligent.lookOver') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenations center">
          <el-pagination
              background
              :page-size="query.limit"
              @current-change="currentChange"
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog
          :title="name"
          top="5vh"
          :visible.sync="centerDialogVisible"
          width="98%"
          center>
        <iframe :src="ifUrl" frameborder="0" style="width:100%;height:750px;"></iframe>
      </el-dialog>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {
  getPathList, getSatelliteList
} from "@/api/jiance"

export default {
  name: 'product-data',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      productList: [],
      expend: false,
      tableList: [],
      ifUrl: '',
      name: '',
      centerDialogVisible: false,
      query: {
        satellite: '',
        limit: 10,
        page: 1
      },
      total: 0,
      activeIndex: 0
    }
  },
  watch: {},
  methods: {
    currentChange(val) {
      this.query.page = val
      this.getInfoList()
    },
    changeIs(val) {
      this.query.satellite = val
      this.getInfoList()
    },
    openPDF(val) {
      window.open(val.downloadUrl)
    },
    async getLeft() {
      const res = await getSatelliteList()
      this.productList = res.data
      this.query.satellite = this.productList[0]
      this.getInfoList()
    },
    async getInfoList() {
      let that = this
      let res = await getPathList(that.query)
      this.tableList = res.data.list
      this.total = parseInt(res.data.totalCount)
    },
    copy(row) {
      let input = document.createElement('input')
      input.value = row.address
      input.id = 'creatDom'
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功！')
    }
  },
  computed: {},
  created() {
    this.getLeft()
  }
}
</script>

<style lang="scss" scoped>
.product-data {
  width: 100%;
  @include map_bg();

  .content {
    display: flex;
    height: 100%;
    width: 1551px;
    margin: 0 auto;
    padding: 14px 0;

    .left {
      width: 260px;
      height: calc(100% - 24px);
      @include product_upload_menu_bg();
      padding: 24px 0;

      .tree-custom {
        .parent {
          cursor: pointer;
          transition: max-height 0.2s ease-in;
          overflow: hidden;

          &-name {
            padding-left: 24px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &-left {
              display: flex;
              align-items: center;
            }

            &-right {
              margin-right: 12px;
              transition: transform 0.5s;
              -moz-transition: -moz-transform 0.5s; /* Firefox 4 */
              -webkit-transition: -webkit-transform 0.5s; /* Safari 和 Chrome */
              -o-transition: -o-transform 0.5s;
            }

            .top {
              transform: rotate(-180deg);
              -webkit-transform: rotate(-180deg);
              -moz-transform: rotate(-180deg);
              -o-transform: rotate(-180deg);
            }

            .down {
              transform: rotate(0deg);
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -o-transform: rotate(0deg);
            }

            img {
              margin-right: 8px;
            }
          }

          .child {
            &-site {
              padding-left: 48px;
              height: 40px;
              display: flex;
              align-items: center;
              font-size: 14px;

              img {
                margin-right: 8px;
              }

              span {
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                white-space: nowrap;
                width: 185px;

                &.active {
                  color: #007bff;
                }
              }
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      @include product_upload_menu_bg();
      padding: 24px;
      margin-left: 12px;

      table {
        width: 100%;
      }

      ::v-deep .btn-next {
        margin-right: 0;
      }

      ::v-deep .el-pagination {
        padding-right: 0;
      }
    }
  }
}

/deep/ .el-table::before {
  background-color: transparent;
}

.site {
  width: 100%;
  height: 200px;
  background: red;
}

/deep/ .lastUpload {
  .el-upload-dragger {
    background: #2D3359;
    border: none;
  }
}

.colorline-pick {
  .color-box {
    margin: 12px 0;
    max-height: 160px;
    width: 100%;
    border-top: 2px solid #B4B7CC;

    .color-site {
      width: 100%;
      display: flex;
      height: 30px;
      border: 2px solid #B4B7CC;
      border-top: none;

      .color-index {
        width: 28px;
        height: 100%;
        border-right: 2px solid #B4B7CC;
        position: relative;

        .delete-mask {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0);
          color: rgba(255, 255, 255, 0);
          z-index: 500;
        }

        .delete-mask:hover {
          background-color: rgba(0, 0, 0, 1);
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
        }
      }

      .color-ca {
        cursor: pointer;
        width: calc(100% - 34px);
        border-right: 2px solid #B4B7CC;
        height: 100%;
        line-height: 28px;
        font-size: 13px;
        position: relative;

        /deep/ .el-color-pick-site {
          opacity: 0;
          position: absolute;
          width: 100%;

          .el-color-picker__trigger {
            width: 100%;
          }
        }
      }
    }
  }

  #yulan {
    width: 100%;
    height: 28px;
    margin: 4px 0 16px 0;
  }

  .btn-tool {
    display: flex;
    justify-content: flex-end;

    .btn-cancel {
      width: 102px;
      height: 36px;
      border: 1px solid #0269FF;
      border-radius: 5px;
      cursor: pointer;

      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0269FF;
    }

    .btn-sure {
      cursor: pointer;
      margin-left: 10px;
      width: 102px;
      height: 36px;
      background: #0269FF;
      border-radius: 5px;

      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
</style>

<style lang="scss">
.delete-sure {
  background: #1B2240;
  box-shadow: 0px 0px 13px 0px rgba(2, 105, 255, 0.3);
  border: none;

  .el-message-box__title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0269FF;
  }

  .el-message-box__message {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #DBDBDB;
  }

  .el-message-box__btns {
    button:first-child {
      width: 80px;
      height: 32px;
      border: 1px solid #0269FF;
      border-radius: 5px;
      background-color: transparent;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0269FF;
    }

    button:last-child {
      width: 80px;
      height: 32px;
      background: #0269FF;
      border-radius: 5px;
      border: none;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: white;
    }
  }
}

.upload-color-line {
  width: 100%;

  div {
    width: 100%;
  }
}

.last-upload {
  position: relative;

  .custom-btn {
    position: absolute;
    left: 380px;
    top: 80px;
  }
}
</style>